import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { ProjectAreas } from './components/ProjectAreas';
import { Benefits } from './components/Benefits';
import { Process } from './components/Process';
import { Funding } from './components/Funding';
import { Philosophy } from './components/Philosophy';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Impressum } from './components/Impressum';
import { Datenschutz } from './components/Datenschutz';
import { SEO } from './components/SEO';
export function App() {
  // Simple routing based on URL search params
  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get('page');
  return <div className="min-h-screen bg-secondary font-sans text-accent selection:bg-primary selection:text-white" data-id="element-0">
      <SEO data-id="element-1" />
      <Navigation data-id="element-2" />

      <main data-id="element-3">
        {page === 'impressum' ? <Impressum data-id="element-4" /> : page === 'datenschutz' ? <Datenschutz data-id="element-5" /> : <>
            <Hero data-id="element-6" />
            <About data-id="element-7" />
            <ProjectAreas data-id="element-8" />
            <Services data-id="element-9" />
            <Benefits data-id="element-10" />
            <Process data-id="element-11" />
            <Funding data-id="element-12" />
            <Philosophy data-id="element-13" />
            <FAQ data-id="element-14" />
            <Contact data-id="element-15" />
          </>}
      </main>

      <Footer data-id="element-16" />
    </div>;
}